export default __webpack_public_path__ + "static/media/step3regis.658d03e1.svg";